import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import Breadcrumbs from '../../../layout/Breadcrumbs';
import TableToolbar from '../../../common/TableToolbar';
import { REPORT_COLUMNS } from '../../../../config/columns';
import {
  getAccountingReports,
  clearAccountingReports,
  clearErrorGettingAccountingReports,
} from '../../../../actions';
import {
  ACCOUNTING_REPORTS_PATH,
  NEW_ACCOUNTING_REPORT_PATH,
} from '../../../../config/paths';
import Alert from '../../../common/informative/Alert';
import Table from '../../../common/Table';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';

class AccountingReports extends Component {
  constructor(props) {
    super(props);
    this.columns = REPORT_COLUMNS;
  }
  componentWillUnmount() {
    this.props.clearErrorGettingAccountingReports();
    this.props.clearAccountingReports();
  }
  renderContent() {
    const { reports, loading, error } = this.props;

    // check if there is an error
    if (error) {
      return <Alert message={error} />;
    }

    let data = [];
    let pages = null;
    let defaultPageSize = DEFAULT_PAGE_SIZE;

    const { columns } = this;

    if (reports) {
      data = reports.get('content');
      pages = reports.get('totalPages');
      defaultPageSize = reports.get('size');
    }

    return (
      <Table
        columns={columns}
        data={data}
        pages={pages}
        defaultPageSize={defaultPageSize}
        fetchData={this.props.getAccountingReports}
        modelPath={ACCOUNTING_REPORTS_PATH}
        loading={loading}
        navigateToModelOnRowClick
      />
    );
  }
  render() {
    return (
      <Container fluid>
        <Breadcrumbs breadcrumbs={this.props.breadcrumbs} />
        <TableToolbar buttonPath={NEW_ACCOUNTING_REPORT_PATH} />
        <h1>Reportes de Contabilidad</h1>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat.
        </p>
        {this.renderContent()}
      </Container>
    );
  }
}

const mapStateToProps = ({ ReportUnit }) => ({
  breadcrumbs: [
    ...ReportUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Contabilidad',
      href: ACCOUNTING_REPORTS_PATH,
    },
  ],
  reports: ReportUnit.AccountingReport.get('all').get('content'),
  loading: ReportUnit.AccountingReport.get('all').get('loading'),
  error: ReportUnit.AccountingReport.get('all').get('error'),
});

const mapDispatchToProps = {
  getAccountingReports,
  clearAccountingReports,
  clearErrorGettingAccountingReports,
};

AccountingReports.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  getAccountingReports: PropTypes.func.isRequired,
  clearErrorGettingAccountingReports: PropTypes.func.isRequired,
  clearAccountingReports: PropTypes.func.isRequired,
  reports: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  error: PropTypes.string,
};
AccountingReports.defaultProps = {
  reports: null,
  loading: false,
  error: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountingReports);
